import React, { useEffect, useState, useContext } from 'react';
import NewGroupLogic from './NewGroupLogic';
import API from '../../../constants/api';
import GroupTable from './GroupTable';
import LocaleContext from '../../../constants/localization';
import { resToJsonHandleErrors } from '../../../helpers/actionHelpers';
import { actionError, actionSuccess } from '../../../actions/viewActions';
import { useDispatch } from 'react-redux';

const ListGroupsView = ({ setSelectedGroup, setEdit }) => {
  const [groups, setGroups] = useState([]);
  const [ssoGroups, setSSOGroups] = useState([]);

  const LS = useContext(LocaleContext);
  const dispatch = useDispatch();

  useEffect(() => {
    refreshGroups();
  }, []);

  const refreshGroups = () => {
    const fetchData = () =>
      fetch(`${API.DAM.MANAGE_GROUPS}?action=listGroupsReact`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.json())
        .then((j) => {
          setGroups(j.groups.filter((g) => !g.createdFromSSO));
          setSSOGroups(j.groups.filter((g) => g.createdFromSSO));
        });

    fetchData();
  };

  const handleDelete = (key, name) => {
    if (!window.confirm(`${LS.manageGroups.deleteConfirm}"${name}"?`)) return;
    const formData = new URLSearchParams();
    formData.append('id', key);
    fetch(`${API.DAM.MANAGE_GROUPS}?action=deleteGroupReact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
    })
      .then((res) => resToJsonHandleErrors(res))
      .then(dispatch(actionSuccess('groupDeleted')))
      .then(() => refreshGroups())
      .catch((e) => dispatch(actionError(e)));
  };

  return (
    <div>
      <h2>{LS.manageGroups.internalGroups}</h2>
      <NewGroupLogic refreshGroups={refreshGroups}></NewGroupLogic>
      <GroupTable
        groups={groups}
        setEdit={setEdit}
        handleDelete={handleDelete}
        createdFromSSO={false}
        setSelectedGroup={setSelectedGroup}
      />
      {ssoGroups?.length > 0 && (
        <>
          <h2>{LS.manageGroups.externalGroups}</h2>{' '}
          <p>{LS.manageGroups.externalGroupsHelp}</p>
          <GroupTable
            groups={ssoGroups}
            setEdit={setEdit}
            handleDelete={handleDelete}
            setSelectedGroup={setSelectedGroup}
            createdFromSSO={true}
          />
        </>
      )}
    </div>
  );
};

export default ListGroupsView;
